import React from "react";
import MainLayout from "../layouts/MainLayout";
import Hero from "../components/common/Hero";
import { ImageGallery, ImageModal } from "../components/ui";
import placeholder from "../assets/images/placeholder.webp";
import { FadeInUp } from "../components/animations/AnimationComponents";
import { useI18n } from "../hooks/useI18n";
import { useInstitutionalOrganization } from "../hooks/useInstitutionalOrganization";

const Gallery: React.FC = () => {
  const { text } = useI18n();
  const institutional = useInstitutionalOrganization();
  const [selectedImageIndex, setSelectedImageIndex] = React.useState<number | null>(null);

  if (!institutional) return null;

  const galleryImages = institutional.galleryImages;

  return (
    <MainLayout>
      <Hero title={text.gallery.heroTitle} subtitle={text.gallery.heroSubtitle} backgroundImage={placeholder} height="medium" />

      <section className="bg-surface-cool py-16">
        <div className="container mx-auto max-w-6xl px-4">
          <FadeInUp delay={0.2}>
            <h2 className="mb-4 text-center text-3xl font-semibold text-foreground">{text.gallery.title}</h2>
            <p className="mx-auto mb-12 max-w-2xl text-center text-lg text-muted-foreground">{text.gallery.body}</p>
          </FadeInUp>

          <FadeInUp delay={0.4}>
            <ImageGallery
              images={galleryImages}
              columns={3}
              gap={6}
              onImageClick={(index) => setSelectedImageIndex(index)}
              className="mb-8"
            />
          </FadeInUp>

          <FadeInUp delay={0.6}>
            <div className="mt-16 text-center">
              <div className="mx-auto max-w-2xl rounded-ui-lg border border-border/80 bg-card p-8 shadow-ui-card">
                <h3 className="mb-4 text-xl font-semibold text-foreground">{text.gallery.shareTitle}</h3>
                <p className="mb-6 text-muted-foreground">{text.gallery.shareBody}</p>
                <a
                  href="/contacto"
                  className="inline-block rounded-ui-sm bg-primary px-6 py-2 font-semibold text-primary-foreground shadow-ui-card transition-[background-color,box-shadow] duration-200 hover:bg-primary-dark hover:shadow-ui-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                >
                  {text.gallery.contact}
                </a>
              </div>
            </div>
          </FadeInUp>
        </div>
      </section>

      <ImageModal
        isOpen={selectedImageIndex !== null}
        onClose={() => setSelectedImageIndex(null)}
        images={galleryImages}
        initialIndex={selectedImageIndex || 0}
      />
    </MainLayout>
  );
};

export default Gallery;
